/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { capitalize, safeNumeral } from '@root/utility'

import Loader from '@Pure/Loader'

const moment  = window.moment;

moment.locale('fr');

const numeral = window.numeral;

numeral.locale('en');

const { app, qwest } = window;

export default class AbondementAddedHistory extends Component
{
	state =
	{
		added: []
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'sessionChange',
			cb: component.getData
		});

		app.push(
		{
			event: 'addedECAbondement',
			cb: component.getData
		});

		component.getData();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.getData
		});

		app.delete(
		{
			event: 'addedECAbondement',
			cb: component.getData
		});
	}

	getData = () =>
	{
		const component = this, props = this.props, state = this.state;

		let EC_id;

		if (props.EC_id)
		{
			EC_id = props.EC_id;
		}
		else if (app.state.session.permissions.title === 'EC')
		{
			EC_id = app.state.session.EC.id;
		}

		if (!EC_id)
		{
			return;
		}

		component.setState(
		{
			loading: true
		});

		qwest.post('/fetch/added-abondements', { EC_id: props.EC_id })
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				added: response.data
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error);

			component.setState({ loading: false });
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let header =
		(
			<div className="c-data-row c-data-row--v2 c-data-row--header">
				<div className="o-grid__item c-data-row__item">Montant ajouté</div>
				<div className="o-grid__item c-data-row__item">Date de l'ajout</div>
				<div className="o-grid__item c-data-row__item">Total avant</div>
				<div className="o-grid__item c-data-row__item">Total après</div>
			</div>
		);

		let rows = state.added.map(function (added)
		{
			let infos = added.data;

			let added_amount = numeral
			(
				safeNumeral(infos.added_amount)
			)
			.format('0[.]00') + ' €';

			let previous_amount = numeral(safeNumeral(infos.previous_amount))
			.format('0[.]00') + ' €';

			let new_amount = numeral(safeNumeral(infos.new_amount))
			.format('0[.]00') + ' €';

			let output =
			(
				<div className="c-data-row c-data-row--v2" key={ added.id }>

					<li className="o-grid__item c-data-row__item">
						{ added_amount }
					</li>

					<li className="o-grid__item c-data-row__item">
						{
							capitalize
							(
								moment(added.createdAt)
								.format('dddd DD MMMM YYYY HH:mm')
							)
						}
					</li>

					<li className="o-grid__item c-data-row__item">
						{ previous_amount }
					</li>

					<li className="o-grid__item c-data-row__item">
						{ new_amount }
					</li>

				</div>
			);

			return output;
		});

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />;
		}

		let output =
		(
			<div className="table-container">

				<div className="c-table">

					{ header }

					{ rows }

				</div>

				{ loader }

			</div>
		);

		return output;
	}
}